<div class="container">
    <!-- Title Page - Print Only -->
    <div class="title-page print-only">
        <div class="title-page-content">
            <div class="logo-container">
                <img src="assets/logo.jpg" alt="VanCon Logo" class="logo" />
            </div>
            <h1 class="main-title">V/TO BUSINESS PLAN</h1>
            <div class="sections-list">
                @for (section of sections; track section.id) {
                    <h3 class="section-title">{{ section.heading }}</h3>
                }
                @if (hasQuarterlyGoalsSection()) {
                    <h3 class="section-title">Active Quarterly Goals</h3>
                }
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <app-business-plan-dashboard [rocks]="quarterlyRocks()" [isLoadingRocks]="isLoadingRocks()"></app-business-plan-dashboard>

            @for (section of sections; track section.id) {
                <div class="mb-4">
                    <div class="section-header-with-buttons">
                        <h2 class="mb-0 section-header">
                            {{ section.heading }}
                        </h2>
                        <div class="section-buttons">
                            @if (canEdit) {
                                @if (!isEditing(section)()) {
                                    <button class="btn btn-sm btn-outline-primary" (click)="startEditing(section)" title="Edit Section">
                                        <fa-icon [icon]="faEdit"></fa-icon>
                                    </button>
                                }
                                @if (isEditing(section)()) {
                                    <button class="btn btn-sm btn-success me-2" (click)="saveSection(section)" title="Save Changes">
                                        <fa-icon [icon]="faSave"></fa-icon>
                                    </button>
                                    <button class="btn btn-sm btn-secondary" (click)="cancelEditing(section)" title="Cancel Editing">
                                        <fa-icon [icon]="faTimes"></fa-icon>
                                    </button>
                                }
                            }
                        </div>
                    </div>
                    <div class="content-section">
                        @if (!isEditing(section)()) {
                            <quill-view [content]="section.content" theme="snow" class="preview-quill-view"></quill-view>
                        }
                        @if (isEditing(section)()) {
                            <quill-editor
                                [(ngModel)]="editedContent()[section.id]"
                                (onContentChanged)="onContentChange(section, $event.html || '')"
                                (onEditorCreated)="onEditorCreated()"
                                theme="snow"
                                class="preview-quill-editor"
                                [modules]="quillModules"
                            ></quill-editor>
                        }
                        @if (isOneYearGoalsSection(section)) {
                            <div class="one-year-goals">
                                <h3 class="one-year-goals-header">Goals for the year</h3>
                                @if (isLoadingRocks()) {
                                    <div class="text-center py-3">
                                        <div class="spinner-border text-primary" role="status">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                        <p class="mt-2 text-muted">Loading 1-year goals...</p>
                                    </div>
                                }
                                @if (!isLoadingRocks() && oneYearGoalRocks().length === 0) {
                                    <p class="text-muted mb-0">No 1-year goals found.</p>
                                }
                                @if (!isLoadingRocks() && oneYearGoalRocks().length > 0) {
                                    <ul class="one-year-goals-list">
                                        @for (rock of oneYearGoalRocks(); track trackByRockId($index, rock)) {
                                            <li>{{ getRockBulletLabel(rock) }}</li>
                                        }
                                    </ul>
                                }
                            </div>
                        }
                    </div>
                </div>
            }

            <!-- Active Quarterly Goals Section Header -->
            @if (hasQuarterlyGoalsSection()) {
                <div class="mb-4">
                    <div class="section-header-with-buttons">
                        <h2 class="mb-0 section-header">Active Quarterly Goals</h2>
                    </div>
                </div>
            }

            <!-- Quarterly Goals Rocks List -->
            @if (hasQuarterlyGoalsSection()) {
                <div class="mb-4">
                    @if (isLoadingRocks()) {
                        <div class="text-center py-3">
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            <p class="mt-2 text-muted">Loading quarterly goals...</p>
                        </div>
                    }

                    @if (!isLoadingRocks() && quarterlyRocks().length === 0) {
                        <div class="empty-rocks-state">
                            <i class="fas fa-info-circle text-muted"></i>
                            <p class="text-muted mb-0">No active quarterly goals found.</p>
                        </div>
                    }

                    @if (!isLoadingRocks() && quarterlyRocks().length > 0) {
                        <div class="rocks-list">
                            @for (rock of quarterlyRocks(); track trackByRockId($index, rock)) {
                                <div class="rock-item">
                                    <div class="rock-header">
                                        <h5 class="rock-name">
                                            <fa-icon [icon]="getRockIcon(rock.type)" class="me-2"></fa-icon>{{ rock.name }}
                                        </h5>
                                        <span class="rock-status" [ngClass]="getStatusClass(rock.status)">
                                            {{ getStatusText(rock.status) }}
                                        </span>
                                    </div>
                                    <!-- Rock details section - commented out for feedback -->
                                    <!-- <div *ngIf="rock.details" class="rock-details">
                                        <quill-view [content]="rock.details" theme="snow" class="rock-description-quill"></quill-view>
                                    </div> -->
                                    <div class="rock-meta">
                                        <div class="rock-dates">
                                            @if (rock.doneDate) {
                                                <span class="due-date">
                                                    <fa-icon [icon]="faCalendarAlt" class="me-1"></fa-icon>Done:
                                                    {{ rock.doneDate | date: 'MMM d, y' }}
                                                </span>
                                            } @else if (rock.dueDate) {
                                                <span class="due-date">
                                                    <fa-icon [icon]="faCalendarAlt" class="me-1"></fa-icon>Due:
                                                    {{ rock.dueDate | date: 'MMM d, y' }}
                                                </span>
                                            }
                                            @if (rock.userNames && rock.userNames.length > 0) {
                                                <span class="due-date">
                                                    <fa-icon [icon]="faUsers" class="me-1"></fa-icon>Assigned to:
                                                    {{ rock.userNames.join(', ') }}
                                                </span>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
            }

            @if (sections.length === 0) {
                <div class="empty-state">
                    <i class="fas fa-info-circle"></i>
                    <h5>No Sections Available</h5>
                    <p>Add some business plan sections to see them in preview mode.</p>
                </div>
            }
        </div>
    </div>
</div>
